import React from 'react';
import Logo from '../../../../images/svg/logo';
import RabenLogo from 'src/images/raben-logo-white-text-cropped.png';
import { styled } from 'styled-components';
import { Divider } from '@mui/material';

const StyledImage = styled.img`
  width: 110px;
  height: auto;
  object-fit: contain;
`;

export default function LogoWithRaben() {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Logo />
      <Divider
        orientation="vertical"
        flexItem
        sx={{
          ml: 1,
          mr: 1,
          bgcolor: '#FFFFFF',
          width: '1px',
        }}
      />
      <StyledImage src={RabenLogo} alt="Raben Logo" />
    </div>
  );
}
